module.exports = __webpack_public_path__ + "media/src/images/partners/buckingham-12aaee5ba701a32ac879280549bcda7e.jpg";